module.exports = __webpack_public_path__ + "static/media/DSC_2063_HDR.29a03f23.jpg";